import { render, staticRenderFns } from "./MCQView.vue?vue&type=template&id=c6fce1a6"
import script from "./MCQView.vue?vue&type=script&lang=js"
export * from "./MCQView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports